import { render } from "./FleetLatestUpdate.vue?vue&type=template&id=3fd9f6a0"
import script from "./FleetLatestUpdate.vue?vue&type=script&lang=js"
export * from "./FleetLatestUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/home/wildan/Projects/assets-tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__